module.exports = "<div class=\"hp-module\">\n\t<div class=\"hp-inner\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n                <div class=\"hp-loading-spinner\" ra-spinner name=\"applicationSpinner\" hide-content-when-shown=\"true\" show=\"true\"></div>\n\t\t\t</div>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/application/application.html
// module id = 945
// module chunks = 1